(function ($) {
    var didScroll;
    var lastScrollTop = 0;
    var minScroll = 5;

    $(window).scroll(function (event) {

        didScroll = true;

    });

    setInterval(function () {

        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }

    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop();
        var navbarHeight = $('#site-header').outerHeight();

        // Make sure they scroll more than minScroll
        if (Math.abs(lastScrollTop - st) <= minScroll)
            return;

        // Scroll Up
        if (st < lastScrollTop) {
            $('body').addClass('header-scrolled-up');
            $('body').removeClass('header-scrolled');
        } else {
            $('body').removeClass('header-scrolled-up');
            $('body').addClass('header-scrolled');
        }

        lastScrollTop = st;

    }

})(jQuery);
